import { MixtureTypeDto } from 'src/store/mixturetypes/mixturetype';
import { ArrayUtils } from 'src/utils/array';
import { ApiError } from '../api-handler';
import { MixtureTypeAction, MixtureTypeTypes } from './mixturetypes.actions';

export type MixtureTypesState = Readonly<{
  mixtureTypes: MixtureTypeDto[];
  errors: Nullable<ApiError>;
}>;

const initialState: MixtureTypesState = {
  mixtureTypes: [],
  errors: null
};

const mixtureTypesReducer = (
  state: MixtureTypesState = initialState,
  action: MixtureTypeAction
) => {
  switch (action.type) {
    case MixtureTypeTypes.FetchAll:
      return { ...state, mixtureTypes: action.mixtureTypes };
    case MixtureTypeTypes.Add:
      return {
        ...state,
        mixtureTypes: [...state.mixtureTypes, action.mixtureType]
      };
    case MixtureTypeTypes.Update:
      // eslint-disable-next-line no-case-declarations
      const {
        id,
        name,
        description,
        candidateAmount,
        candidateSameGrade,
        candidateSameSpec,
        candidateLot,
        candidateSpec,
        candidateSpecCustomer,
        completeCount,
        completeAmount,
        completeSpec,
        completeSpecCustomer,
        runLotCreate,
        runLotComplete,
        candidateCount
      } = action.mixtureType;
      return {
        ...state,
        mixtureTypes: state.mixtureTypes.map(mixtureType =>
          mixtureType.id === id
            ? {
                ...mixtureType,
                name,
                description,
                candidateAmount,
                candidateSameGrade,
                candidateSameSpec,
                candidateLot,
                candidateSpec,
                candidateSpecCustomer,
                completeCount,
                completeAmount,
                completeSpec,
                completeSpecCustomer,
                runLotCreate,
                runLotComplete,
                candidateCount
              }
            : mixtureType
        )
      };
    case MixtureTypeTypes.Delete:
      return {
        ...state,
        mixtureType: null,
        mixtureTypes: ArrayUtils.deleteFromListById(
          state.mixtureTypes,
          action.mixtureType
        )
      };
    case MixtureTypeTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default mixtureTypesReducer;
